import { render } from "./KnFabButton.vue?vue&type=template&id=3795a670&scoped=true&ts=true"
import script from "./KnFabButton.vue?vue&type=script&lang=ts"
export * from "./KnFabButton.vue?vue&type=script&lang=ts"

import "./KnFabButton.vue?vue&type=style&index=0&id=3795a670&scoped=true&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3795a670"]])

export default __exports__